import { getSentryEnv } from "@lobby/utils-formatters";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import { App } from "./app";

if (import.meta.env.PROD) {
  Sentry.init({
    release: import.meta.env.VITE_APP_VERSION,
    dsn: "https://59319574596e8756cf3a2bc0895fd72b@errorcollect.com/22",
    tracesSampleRate: 0.2,
    environment: getSentryEnv(),
  });
}

polyfillCountryFlagEmojis();

// @ts-expect-error
createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
